import React, { FC, useCallback, useContext } from 'react';
import { useSelector } from 'react-redux';
import { useHistory } from 'react-router-dom';

import { Button, ButtonIntent, ButtonType } from 'app/design-system/components/Button';
import { Icon, IconSize } from 'app/design-system/components/Icon';
import { Modal } from 'app/design-system/components/Modal';
import { useTranslation } from 'app/lang';
import { processing } from 'app/redux/selectors/auth';
import { allowFreshChat } from 'app/ssr/config';

import { AuthContext } from '../../../context';
import { SigningHelpButton } from '../../SigningHelpButton';

import dictionary from './AuthorizationFooter.dictionary.json';

import styles from './AuthorizationFooter.module.scss';

export const AuthorizationFooter: FC = () => {
  const { t } = useTranslation();
  const history = useHistory();
  const { authData: { loginDataChecked, isEmptyField, shake } } = useContext(AuthContext);

  const authorizationLoading = useSelector(processing);

  const handleClose = useCallback(() => {
    history.push('');
    sessionStorage.removeItem('phone');
  }, []);

  return (
    <Modal.Footer>
      {allowFreshChat && <SigningHelpButton />}
      <Button type={ButtonType.BUTTON}
              intent={ButtonIntent.DEFAULT}
              onClick={handleClose}
              disabled={authorizationLoading || loginDataChecked}
              className={styles.footerCancelButton}
              data-test="login-cancel">
        {t(dictionary.cancel)}
      </Button>

      <Button type={ButtonType.SUBMIT}
              intent={loginDataChecked ? ButtonIntent.SUCCESS : ButtonIntent.CALL_TO_ACTION}
              form="authorizationForm"
              disabled={isEmptyField || shake}
              loading={authorizationLoading}
              className={styles.footerEnterButton}
              data-test="login-submit">
        {!loginDataChecked
          ? t(dictionary.submitText)
          : (
            <Icon icon="check"
                  size={IconSize.SMALL}
                  className={styles.iconSuccess} />
          )}
      </Button>
    </Modal.Footer>
  );
};
